module.exports = __webpack_public_path__ + "images/for_company_page/title-number2_4e5f18f78cb2356054e5960ba7096073.jpg";